<template lang="pug">
  ul.timeline
    li.item(v-for="(item, index) in timeline" :key="index")
      .year
        h2 {{item.year}}
        ul.milestones
          li.milestone(v-for="(milestone, ind) in item.milestones" :key="ind")
            //- code {{milestone}}
            figure(v-if="milestone.img && milestone.img.length > 0")
              img(:src="milestone.img", alt="")
            h3
              a(:href="milestone.url" v-if="milestone.url" target="_blank")
                span {{milestone.text}}
              span(v-if="!milestone.url") {{milestone.text}}

</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['timeline'])
  }
}
</script>
<style lang="scss" scoped>
.timeline{
  max-width: $overwidth;
  margin: 1rem auto;
  font-family: 'LaTercera', sans-serif;
}
.item{
  margin-bottom: 1rem;
  h2{
    font-size: 6rem;
    letter-spacing: -6px;
    margin-bottom: 2rem;
  }
}
ul{
  padding: 0;
}

ul.timeline{
  @media (max-width: 800px){
    padding: 1rem;
  }
  li.item{
    list-style-type: none;
    position: relative;
    width: 6px;
    margin: 0 auto;
    padding-top: 50px;
    background: #fff;
    &::before{
      display: none;
    }
    @media (max-width: 800px){
      margin: 0;
    }
    &::after{
      background: #fff;
    }
    .year{
      width: ($overwidth / 2);
      position: relative;
      ul{
        padding: none;
        margin: none;
      }
      li{
        list-style: none;
      }
      @media (max-width: 800px){
        width: 90vw;
        margin: 1rem;
      }
    }
    h3{
      font-size: 1.2rem;
      line-height: 120%;
    }
    &:nth-child(odd){
      .year{
        left: -( ($overwidth / 2) + 30px);
        text-align: right;
        @media (max-width: 800px){
          left: 0;
          text-align: left;
        }
      }
    }
    &:nth-child(even){
      .year{
        left: 30px;
        @media (max-width: 800px){
          left: 0;
        }
      }
    }
  }
}

</style>


